@for (orderItem of orderItems; track orderItem; let i = $index) {
  @if (i < 5 || showAllOrderItems) {
    <div class="row order-summary-row">
      <div class="col-9">
        <div class="group-name">{{ orderItem.name }}</div>
        <div class="order-item-name">{{ orderItem.orderItem.name }}</div>
      </div>
      <div class="col-3 text-right">
        {{ orderItem.price | currency }}
        @for (costItemAgreement of orderItem.additionalCosts; track costItemAgreement) {
          @if (costItemAgreement.amount > 0) {
            <div class="order-item-cost-item-agreement">
              {{ costItemAgreement.label }}: {{ costItemAgreement.amount | currency:costItemAgreement.currencyId }}
            </div>
          }
        }
      </div>
    </div>
  }
}

@if (order.orderItemAmount > 5 && showAllOrderItems === false) {
  <div class="row">
    <div class="col-12 text-center">
      <button class="btn btn-secondary" (click)="showAllOrderItems = true">
        {{ ('Order_Summary.Show_All_Order_Items' | trans | tags:[{
        key: 'amount',
        value: order.orderItemAmount
        }]) }}
      </button>
    </div>
  </div>
}

<div class="discounts">
  @for (discount of order.discounts; track discount) {
    <div class="row order-summary-row">
      <div class="col-9">
        {{ discount.name }}
      </div>
      <div class="col-3 text-right">
        -{{ discount.amount | currency}}
      </div>
    </div>
  }
</div>

<div class="row order-summary-row order-summary-total">
  <div class="col-9">
    @if (order.totalDiscountAmount > 0) {
      {{('Order_Table.Price_After_Discount' | trans)}}
    }
    @if (order.totalDiscountAmount === 0) {
      {{('Order_Table.Price' | trans)}}
    }
  </div>
  <div class="col-3 text-right">
    {{order.getPrice()| currency}}
  </div>
</div>

<ng-template #orderItemRow let-group="group" let-orderItem="orderItem" let-orderItemItem="orderItemItem">
  <div class="row order-summary-row">
    <div class="col-9">
      <div class="group-name">{{ group.name }}</div>
      <div class="order-item-name">{{ orderItemItem.name }}</div>
    </div>
    <div class="col-3 text-right">
      {{ orderItem.price | currency:orderItem.currency }}
    </div>
  </div>
</ng-template>
